import { Button, Paper, Stack } from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { ApiError } from "../../Api/ApiError";
import { getStudioPackList } from "../../Api/Store";
import { StudioPack } from "../../Objects/StudioPack";
import { StoreObjectStore } from "../../ObjectStore/StoreObjectStore";
import CategoryTitle from "../atoms/CategoryTitle";
import StudioPackEditDialog from "./StudioPackEditDialog";
import StudioPackList from "./StudioPackList";


const StoreDetailStudioPack: React.FC = () => {
    let { enqueueSnackbar } = useSnackbar()
    const { storeObjectState } = React.useContext(StoreObjectStore)
    const [studioPackList, setStudioPackList] = React.useState<StudioPack[]>([])
    const [studioPackEditDialogOpen, setStudioPackEditDialogOpen] = React.useState<boolean>(false)
    const [studioPackEdit, setStudioPackEdit] = React.useState<StudioPack>()

    const abortController = React.useMemo(() => new AbortController(), [])

    React.useEffect(() => {
        return () => {
            abortController.abort()
        }
    }, [abortController])

    const loadStudioPackList = React.useCallback(() => {
        if (storeObjectState.storeData && storeObjectState.storeData?.str_id) {
            getStudioPackList({
                str_id: storeObjectState.storeData.str_id
            }, {signal: abortController.signal}).then(value => {
                setStudioPackList(value.studioPackList)
            }).catch((e: any) => {
                if( e.__CANCEL__ ) {
                    console.info("canceled")
                } else if (e instanceof ApiError) {
                    enqueueSnackbar(e.message, { variant: "error" })
                } else if (e instanceof Error) {
                    enqueueSnackbar(e.message, { variant: "error" })
                }else {
                    enqueueSnackbar("通信に失敗しました", { variant: "error" })
                }
            })

        }
    }, [abortController, storeObjectState.storeData, enqueueSnackbar])

    React.useEffect(() => {
        loadStudioPackList()
    }, [loadStudioPackList])

    return (
        <Paper sx={{ mt: 2, pb: 2 }}>
            <CategoryTitle
                text="パック料金設定"
            />
            <Stack
                direction="row"
                justifyContent="flex-end"
                sx={{
                    m: 2
                }}
            >
                <Button
                    variant="outlined"
                    onClick={() => {
                        setStudioPackEditDialogOpen(true)
                    }}
                >パック料金を追加</Button>
            </Stack>
            {studioPackList &&
                <StudioPackList
                    studioPackList={studioPackList}
                    onEdit={studioPack => {
                        setStudioPackEdit(studioPack)
                        setStudioPackEditDialogOpen(true)
                    }}
                />
            }
            <StudioPackEditDialog
                open={studioPackEditDialogOpen}
                editStudioPack={studioPackEdit}
                onClose={(isEdit) => {
                    if (isEdit) {
                        loadStudioPackList()
                    }
                    setStudioPackEdit(undefined)
                    setStudioPackEditDialogOpen(false)
                }}
            />
        </Paper>
    );
}

export default StoreDetailStudioPack